import { render, staticRenderFns } from "./FormRO04_2.vue?vue&type=template&id=310a191b"
import script from "./FormRO04_2.vue?vue&type=script&lang=js"
export * from "./FormRO04_2.vue?vue&type=script&lang=js"
import style0 from "./FormRO04_2.vue?vue&type=style&index=0&id=310a191b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports